module.exports = __webpack_public_path__ + "img/evaluate_good.647e952c.svg";